import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { AuthService } from './../services/auth.service';
import { StripeService } from './../services/stripe.service';
import { Observable, of, from } from 'rxjs';
import { switchMap, map, take, catchError } from 'rxjs/operators';
import { AngularFirestore } from '@angular/fire/firestore';
declare var $: any;

@Injectable({
  providedIn: 'root'
})
export class SubscriptionGuard implements CanActivate {
  constructor(private auth: AuthService, private router: Router, private stripeService: StripeService, private db: AngularFirestore) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    console.log('Guard');
    return this.auth.$user.pipe(
      take(1),
      switchMap(user => {
        if (!user) {
          this.router.navigate(['/registro']);
          return of(false);
        }

        // Get user document from Firestore
        return this.db.collection('users').doc(user.uid).get().pipe(
          switchMap(u => {
            // Validate if there's a node in firestore for this user
            if (!u.exists) {
              console.log(`User document for ${user.uid} doesn't exist.`);
              this.router.navigate(['/registro']);
              $.NotificationApp.send('Error', `Subscription for user ${user.uid} doesn't exist.`, 'bottom-right', '#fa5c7c', 'error', 10000);
              return of(false);
            }

            const data = u.data();
            const subscriptionId = data['subscription'];

            if (!subscriptionId) {
              console.log(`No subscription ID found for user ${user.uid}.`);
              this.router.navigate(['/registro']);
              $.NotificationApp.send('Error', 'No subscription found.', 'bottom-right', '#fa5c7c', 'error', 10000);
              return of(false);
            }

            // Query Stripe to check subscription info - convert Promise to Observable
            return from(this.stripeService.getSubscription(subscriptionId)).pipe(
              map(subscriptionResponse => {
                // Handle the nested response structure: { success: true, subscription: {...} }
                if (!subscriptionResponse || !subscriptionResponse.subscription) {
                  console.log('Invalid subscription response structure');
                  this.router.navigate(['/mi-cuenta']);
                  $.NotificationApp.send('Error', 'Invalid subscription data.', 'bottom-right', '#fa5c7c', 'error', 10000);
                  return false;
                }

                const subscription = subscriptionResponse.subscription;
                const status = subscription.status;
                
                console.log('Subscription status:', status);
                
                // Check if subscription is active or trialing
                if (status === 'trialing' || status === 'active') {
                  return true;
                } else {
                  // Subscription is not active
                  console.log('Subscription is not active. Status:', status);
                  this.router.navigate(['/mi-cuenta']);
                  $.NotificationApp.send('Error', 'Your subscription is not active.', 'bottom-right', '#fa5c7c', 'error', 10000);
                  return false;
                }
              }),
              catchError(error => {
                console.log('Error getting subscription:', error);
                const errorMessage = (error && error.error && error.error.error && error.error.error.message) 
                  ? error.error.error.message 
                  : 'Error checking subscription status.';
                this.router.navigate(['/registro']);
                $.NotificationApp.send('Error', errorMessage, 'bottom-right', '#fa5c7c', 'error', 10000);
                return of(false);
              })
            );
          }),
          catchError(error => {
            console.log('Error accessing user document:', error);
            this.router.navigate(['/registro']);
            $.NotificationApp.send('Error', 'Error accessing user data.', 'bottom-right', '#fa5c7c', 'error', 10000);
            return of(false);
          })
        );
      }),
      catchError(error => {
        console.log('Error in guard:', error);
        this.router.navigate(['/registro']);
        return of(false);
      })
    );
  }
  
}
